import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { DeclarationsAuthService } from '../auth/declarations-auth.service';
import { ROLE_GVA_ADMIN, ROLE_HK_ADMIN, ROLE_UK_ADMIN } from '../shared/constants';
import { combineLatest } from 'rxjs';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { ComplianceDashboardComponent } from '../hk/compliance-dashboard/compliance-dashboard.component';
import { GVAAdminDashboardComponent } from '../geneva/admin-dashboard/admin-dashboard.component';
import { UkAdminDashboardComponent } from '../uk/uk-admin-dashboard/uk-admin-dashboard.component';

@Component({
  selector: 'ad-admin-dashboard',
  template: `
    <mat-card class="bg-white">
      @if (hasMultipleAdminRoles) {
        <mat-tab-group>
          @if (isHkAdmin) {
            <mat-tab label="Hong Kong">
              <ad-compliance-dashboard />
            </mat-tab>
          }
          @if (isGvaAdmin) {
            <mat-tab label="Geneva">
              <ad-gva-admin-dashboard />
            </mat-tab>
          }
          @if (isUkAdmin) {
            <mat-tab label="UK">
              <ad-uk-admin-dashboard />
            </mat-tab>
          }
        </mat-tab-group>
      } @else if (isHkAdmin) {
        <mat-card-header>
          <mat-card-title> Hong Kong</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ad-compliance-dashboard />
        </mat-card-content>
      } @else if (isGvaAdmin) {
        <mat-card-header>
          <mat-card-title> Geneva</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ad-gva-admin-dashboard />
        </mat-card-content>
      } @else if (isUkAdmin) {
        <mat-card-header>
          <mat-card-title>UK</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ad-uk-admin-dashboard />
        </mat-card-content>
      }
    </mat-card>
  `,
  styles: ['mat-card { padding: 0 }', 'mat-card-title { padding: 1rem }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ComplianceDashboardComponent,
    GVAAdminDashboardComponent,
    MatCardModule,
    MatTabsModule,
    UkAdminDashboardComponent
  ]
})
export class AdminDashboardComponent implements OnInit {
  protected hasMultipleAdminRoles!: boolean;
  protected isHkAdmin = false;
  protected isGvaAdmin = false;
  protected isUkAdmin = false;

  constructor(private authService: DeclarationsAuthService) {}

  public ngOnInit(): void {
    combineLatest([
      this.authService.hasRole$(ROLE_HK_ADMIN),
      this.authService.hasRole$(ROLE_GVA_ADMIN),
      this.authService.hasRole$(ROLE_UK_ADMIN)
    ]).subscribe(([isHKAdmin, isGvaAdmin, isUkAdmin]) => {
      this.hasMultipleAdminRoles = [isHKAdmin, isGvaAdmin, isUkAdmin].filter((r) => r).length > 1;
      this.isHkAdmin = isHKAdmin;
      this.isGvaAdmin = isGvaAdmin;
      this.isUkAdmin = isUkAdmin;
    });
  }
}
